import { render, staticRenderFns } from "./BtnEditGesDoc.vue?vue&type=template&id=65ac2766&scoped=true"
import script from "./BtnEditGesDoc.vue?vue&type=script&lang=js"
export * from "./BtnEditGesDoc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ac2766",
  null
  
)

export default component.exports